import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  typography: {
    fontFamily: '"Noto Sans", "Noto Sans Bengali", sans-serif'
  },
  palette: {
    primary: {
      main: '#ffcb37',
      contrastText: '#fff'
    },
    secondary: {
      main: '#0068a9',
      contrastText: '#fff'
    }
  }
});

export default theme;
